module.exports = __webpack_public_path__ + "media/fonts/Oricons-8d532c4838a3855faaaea7a45bb3a4b6.ttf";